import * as React from 'react';
export const sofiSvg = React.forwardRef(function sofiSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00A1C5',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.475 6.273a3.176 3.176 0 1 1-2.575 5.81 3.176 3.176 0 1 1 2.575-5.81Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.91 10.472A3.179 3.179 0 0 0 13.098 7.9a3.179 3.179 0 0 0 5.812 2.573Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M22.822 6.031c-1.726 0-3.179 1.453-3.179 3.177 0 1.725 1.453 3.177 3.179 3.177 1.725 0 3.178-1.452 3.178-3.177 0-1.724-1.453-3.177-3.178-3.177Zm0 .817c1.271 0 2.27.999 2.27 2.27 0 1.27-.999 2.269-2.27 2.269a2.248 2.248 0 0 1-2.27-2.27c0-1.27.998-2.269 2.27-2.269Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M24.335 18.799a3.176 3.176 0 1 0-3.037-5.582 3.176 3.176 0 1 0 3.037 5.582Zm1.269 2.499a3.18 3.18 0 0 1-5.584 3.035 3.179 3.179 0 0 1 5.584-3.035Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16.011 12.839c-1.725 0-3.178 1.452-3.178 3.177 0 1.724 1.453 3.177 3.178 3.177 1.725 0 3.178-1.453 3.178-3.177 0-1.725-1.453-3.177-3.178-3.177Zm0 .907c.636 0 1.18.273 1.634.636.455.454.636.998.636 1.634 0 1.27-.999 2.269-2.27 2.269-.636 0-1.18-.272-1.635-.636-.454-.453-.635-.998-.635-1.633-.091-1.271.999-2.27 2.27-2.27Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.466 13.086a3.176 3.176 0 1 1-2.574 5.81 3.176 3.176 0 1 1 2.574-5.81Zm8.427 11.012a3.179 3.179 0 0 0-5.812-2.573 3.179 3.179 0 0 0 5.812 2.573Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.022 22.823c0-1.724 1.453-3.177 3.178-3.177 1.726 0 3.179 1.453 3.179 3.177C12.379 24.548 10.926 26 9.2 26c-1.725 0-3.178-1.452-3.178-3.177Zm4.813-1.634c-.454-.363-1-.635-1.635-.635-1.271 0-2.36.998-2.27 2.27 0 1.27.999 2.268 2.27 2.268 1.272 0 2.27-.998 2.27-2.269 0-.635-.181-1.18-.635-1.634Z',
      fill: '#fff',
    }),
  );
});
sofiSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var sofi = {
  category: 'brand',
  colorable: false,
  name: 'sofi',
  svg: sofiSvg,
};
